export default __webpack_public_path__ + "static/media/1f1e9fe8b29328f6.b48098305a5bb2236cb53ae7210dbe70.svg";